const helpers = {
  isEmpty: function (property) {
    return (property === null || property === '' || typeof property === 'undefined' || property.length === 0)
  },

  setQueryStringParameter: function (name, value) {
    const params = new URLSearchParams(window.location.search)
    if (this.isEmpty(value) && !this.isEmpty(this.getQueryParameter(name))) {
      params.delete(name)
    } else if (!this.isEmpty(value)) {
      params.set(name, value)
    }
    const url = `${window.location.pathname}?${params}`
    window.history.replaceState({}, '', url)
    return url
  },

  getQueryParameter: function (name, isArray) {
    const urlParams = new URLSearchParams(window.location.search)
    const param = urlParams.get(name)
    if (isArray) {
      const array = []
      param.split(',').forEach(id => array.push(parseInt(id)))
      return array
    }
    return param
  },

  convertArray: function (array) {
    return array.map(function (o) {
      if (typeof o === 'object') {
        return o.id
      }
      return o
    })
  },
  containUrl: function (obj, list) {
    let i
    for (i = 0; i < list.length; i++) {
      if (list[i].url === obj.url) {
        return true
      }
    }
    return false
  },
  arrayRemove: function (arr, value) {
    return arr.filter(function (ele) {
      return ele !== value
    })
  }
}

export default helpers
